export function noop() {}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-image-magnify/dist/es/utils/index.js
// module id = 63
// module chunks = 0